// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-501ae020]{display:flex;align-items:center}.banner .text[data-v-501ae020]{flex:1}.values tr td[data-v-501ae020]:not(:first-of-type){padding-left:10px}", ""]);
// Exports
module.exports = exports;
